import React from "react";
import { Container, Row } from "react-bootstrap";
import "../../styles/AccessDenied.scss";

export default function AccessDenied() {
  return (
    <>
      <Container fluid className="p-5">
        <Row className="mt-3">
          <div className="custom-access-denied-container p-4">
            <div className="access-denied-text font-60">Access Denied</div>
            <div className="access-denied-text pt-4">
              You dont have permission to view this page. Request access from
              the administrator.
            </div>
          </div>
        </Row>
      </Container>
      <div className="background-mvs-image type-1"></div>
    </>
  );
}
